import React from 'react';

const OurPilots = () => {
    return (
        <div>
            <h1>OurPilots</h1>
        </div>
    );
};

export default OurPilots;